import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  row: 50,
  column: 50,
  zoom: 40,
  pixelValue: 20,
  unit: "ft",
  addStructure: false
};

export const gridInfo = createSlice({
  name: "gridInfo",
  initialState: initialState,
  reducers: {
    updateGridInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateGridInfo } = gridInfo.actions;

export default gridInfo.reducer;